import React from 'react'
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react'

const Contact = () => {
  return (
    <div className="container mx-auto px-4 py-8 mt-28">
      <h2 className="text-5xl font-serif text-[#0077b6] text-center mb-4">Get in Touch</h2>
      <p className="text-center text-gray-600 mb-12 max-w-xl mx-auto">
        Contact us for product inquiries, customer support, or general information.
      </p>

      <div className="flex flex-col lg:flex-row gap-8 max-w-5xl mx-auto items-stretch">
        {/* Info card */}
        <div className="flex-1 bg-white shadow-md rounded-lg p-6 flex flex-col">
          <h3 className="text-xl font-semibold mb-6">Contact Information</h3>

          <div className="space-y-5">
            <div className="flex items-start gap-3">
              <Phone className="w-5 h-5 text-[#0077b6] mt-0.5 shrink-0" />
              <div>
                <p className="text-gray-700 font-semibold">Phone</p>
                <a href="tel:+251911183048" className="block text-gray-600 hover:text-[#0077b6]">
                  +251 911 183 048
                </a>
                <a href="tel:+251944140354" className="block text-gray-600 hover:text-[#0077b6]">
                  +251 94 414 0354
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-[#0077b6] mt-0.5 shrink-0" />
              <div>
                <p className="text-gray-700 font-semibold">Email</p>
                <a 
                  href="mailto:info@sabeanwatermeter.com"
                  className="text-gray-600 hover:text-[#0077b6]"
                >
                  info@sabeanwatermeter.com
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-[#0077b6] mt-0.5 shrink-0" />
              <div>
                <p className="text-gray-700 font-semibold">Address</p>
                <p className="text-gray-600">Kera, Kirkos Subcity, Addis Ababa, Ethiopia</p>
              </div>
            </div>
          </div>

          <div className="mt-auto pt-8 text-center">
            <a 
              href="mailto:info@sabeanwatermeter.com"
              className="inline-flex items-center gap-2 bg-[#0077b6] text-white px-5 py-2.5 rounded hover:bg-[#0b557c] transition-colors"
            >
              Contact Us <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Map */}
        <div className="flex-1 min-h-[320px] lg:min-h-0">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d744.0662574460972!2d38.75275876295437!3d8.986940311959057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOMKwNTknMTMuNCJOIDM4wrA0NScxMC40IkU!5e0!3m2!1sen!2set!4v1714642044088!5m2!1sen!2set"
            title="Google Map"
            className="w-full h-full min-h-[320px] border border-[#0077b6] rounded-lg"
            frameBorder="0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  )
}

export default Contact